import { Box, Button, List, Collapse } from "@mui/material"
import { useNavigate, useLocation } from "react-router-dom"
import React, { useState } from "react"
import ExpandLessIcon from "@mui/icons-material/ExpandLess"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import { NavListItem } from "./styles"
import { trackEvent } from "utils/analytics"

export const NavItem = props => {
  const { id, parentId, href, target, icon, title, items: children, danger, ...others } = props
  const location = useLocation()
  // "/" must be matched exactly — otherwise every path "includes" it and the
  // Home item stays highlighted forever.
  const active = href ? (href === "/" ? location.pathname === "/" : location.pathname.includes(href)) : false
  const shouldExpand = children ? children.some(x => location.pathname.includes(x.href)) : false
  const navigate = useNavigate()
  const [open, setOpen] = useState(false)

  const handleClick = () => {
    trackEvent("menu_click", { menu_item: (id || "").replace(/-/g, "_"), menu_parent: (parentId || "").replace(/-/g, "_") })
    if (children && children.length > 0) setOpen(prev => !prev)
    else {
      if (typeof href === "function") href()
      else if (target) {
        window.open(href, target, "noopener,noreferrer")
      } else navigate(href)
    }
  }

  if (shouldExpand && !open) setOpen(shouldExpand)

  return (
    <>
      <NavListItem disableGutters {...others}>
        <Button
          id={id}
          startIcon={icon}
          disableRipple
          sx={{
            backgroundColor: active ? "#F3DA00" : "transparent",
            borderRadius: 2.5,
            color: active ? "#12131A" : danger ? "#E5686B" : "#8A93A7",
            fontWeight: active ? 700 : 600,
            fontSize: 13.5,
            justifyContent: "flex-start",
            px: 1.5,
            py: 1,
            flex: 1,
            textAlign: "left",
            textTransform: "none",
            width: "100%",
            "& .MuiButton-startIcon": {
              color: active ? "#12131A" : danger ? "#E5484D" : "#8A93A7",
            },
            "&:hover": {
              backgroundColor: active ? "#F3DA00" : danger ? "rgba(229,72,77, 0.14)" : "rgba(255,255,255, 0.06)",
              color: active ? "#12131A" : danger ? "#FF9A9D" : "#E9EBF1",
            },
          }}
          onClick={handleClick}
          endIcon={children && children.length > 0 ? open ? <ExpandLessIcon /> : <ExpandMoreIcon /> : null}
        >
          <Box sx={{ flexGrow: 1 }}>{title}</Box>
        </Button>
      </NavListItem>
      {children && children.length > 0 && (
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding style={{ marginLeft: 30, paddingLeft: 6, borderLeft: "1.5px solid rgba(255,255,255,0.10)" }}>
            {children.map((item, key) => (
              <NavItem id={item.id} parentId={id} key={item.title} icon={item.icon} href={item.href} title={item.title.toUpperCase()} items={item.children} />
            ))}
          </List>
        </Collapse>
      )}
    </>
  )
}
